import { LayerVisibilityMode } from '@/modules/common/types/layers';

type LayerVisibilityInput = {
  visibilityMode: LayerVisibilityMode;
  parentVisible: boolean;
  zoom: number;
  showFromZoom?: number;
  hideFromZoom?: number;
};

const isVisibleByZoom = (zoom: number, showFromZoom?: number, hideFromZoom?: number): boolean => {
  if (showFromZoom !== undefined && zoom < showFromZoom) return false;
  if (hideFromZoom !== undefined && zoom >= hideFromZoom) return false;

  return true;
};

export const getEffectiveLayerVisibility = ({
  visibilityMode,
  parentVisible,
  zoom,
  showFromZoom,
  hideFromZoom,
}: LayerVisibilityInput): boolean => {
  if (!parentVisible) return false;
  if (visibilityMode === 'force_hide') return false;
  if (visibilityMode === 'force_show') return true;

  return isVisibleByZoom(zoom, showFromZoom, hideFromZoom);
};
